<!--  -->
<template>
<div class='sceneiframe'>
    <iframe :src="`${link}`" ></iframe>
    <bar :active='-1'></bar>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import bar from '../layout/sidebar.vue'
export default {
//import引入的组件需要注入到对象中才能使用
components: {
    bar:bar
},
data() {
//这里存放数据
return {
    link:'',
    scene:'',
    scenes: [{
                        name: '红井',
                        id: 1,
                        intro: '',
                        pano: '1231',
                        img: require('../../assets/images/scenes/红井.png'),
                        imghover: require('../../assets/images/scenes/active/红井.png'),


                    }, {
                        name: '瑞金纪念馆',
                        id: 2,
                        intro: '',
                        pano: '1167',
                        img: require('../../assets/images/scenes/瑞金纪念馆.png'),
                        imghover: require('../../assets/images/scenes/active/瑞金纪念馆.png'),

                    }, {
                        id: 3,
                        name: '沙洲坝中华苏维埃共和国中央人民委员会旧址',
                        intro: '',
                        pano: '1214',
                        img: require('../../assets/images/scenes/沙洲坝中华苏维埃共和国中央人民委员会旧址.png'),
                        imghover: require('../../assets/images/scenes/active/沙洲坝中华苏维埃共和国中央人民委员会旧址.png'),

                    }, {
                        name: '沙洲坝中华苏维埃共和国中央执行委员会旧址',
                        id: 4,
                        intro: '',
                        pano: '1230',
                        img: require('../../assets/images/scenes/沙洲坝中华苏维埃共和国中央执行委员会旧址.png'),
                        imghover: require('../../assets/images/scenes/active/沙洲坝中华苏维埃共和国中央执行委员会旧址.png'),

                    }, {
                        name: '叶坪博生堡',
                        id: 5,
                        intro: '',
                        pano: '1219',
                        img: require('../../assets/images/scenes/叶坪博生堡.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪博生堡.png'),

                    },
                    {
                        name: '叶坪红军检阅台',
                        id: 6,
                        intro: '',
                        pano: '1228_2',
                        img: require('../../assets/images/scenes/叶坪红军检阅台.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军检阅台.png'),

                    }, {
                        name: '叶坪红军烈士纪念塔',
                        id: 7,
                        intro: '',
                        pano: '1228_1',
                        img: require('../../assets/images/scenes/叶坪红军烈士纪念塔.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军烈士纪念塔.png'),

                    },
                    {
                        name: '叶坪红军烈士纪念亭',
                        id: 8,
                        intro: '',
                        pano: '1222',
                        img: require('../../assets/images/scenes/叶坪红军烈士纪念亭.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军烈士纪念亭.png'),

                    }, {
                        name: '叶坪红军无线电总队旧址',
                        id: 9,
                        intro: '',
                        pano: '1224',
                        img: require('../../assets/images/scenes/叶坪红军无线电总队旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军无线电总队旧址.png'),

                    },
                    {
                        name: '叶坪公略亭',
                        id: 10,
                        intro: '',
                        pano: '1216',
                        img: require('../../assets/images/scenes/叶坪公略亭.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪公略亭.png'),

                    },
                    {
                        name: '叶坪红色中华通讯社旧址',
                        id: 11,
                        intro: '',
                        pano: '1215',
                        img: require('../../assets/images/scenes/叶坪红色中华通讯社旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红色中华通讯社旧址.png'),

                    }, {
                        name: '叶坪中国共产党苏维埃区域中央局旧址',
                        id: 12,
                        intro: '',
                        pano: '1268',
                        img: require('../../assets/images/scenes/叶坪中国共产党苏维埃区域中央局旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中国共产党苏维埃区域中央局旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国出版局旧址',
                        id: 13,
                        intro: '',
                        pano: '1217',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国出版局旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国出版局旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国国家银行旧址',
                        id: 14,
                        intro: '',
                        pano: '1223',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国国家银行旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国国家银行旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国临时中央政府电话总机室旧址',
                        id: 15,
                        intro: '',
                        pano: '1226',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国临时中央政府电话总机室旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国临时中央政府电话总机室旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国临时中央政府旧址',
                        id: 16,
                        intro: '',
                        pano: '1225',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国临时中央政府旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国临时中央政府旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国邮政局旧址',
                        id: 17,
                        intro: '',
                        pano: '1233',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国邮政局旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国邮政局旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国中央传令排旧址',
                        id: 18,
                        intro: '',
                        pano: '1229',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国中央传令排旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国中央传令排旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国中央革命军事委员会旧址',
                        id: 19,
                        intro: '',
                        pano: '1227',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国中央革命军事委员会旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国中央革命军事委员会旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国中央警卫营旧址',
                        id: 20,
                        intro: '',
                        pano: '1221',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国中央警卫营旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国中央警卫营旧址.png'),

                    }, {
                        name: '叶坪中华苏维埃共和国总金库旧址',
                        id: 21,
                        intro: '',
                        pano: '1218',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国总金库旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国总金库旧址.png'),

                    }
                ],
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    '$route':function(newval){
        console.log(newval.query.id)
        // if(newval.query.id==1||newval.query.id==2||newval.query.id==4){
        //     this.link = "model/index.html?id="+newval.query.id
        // }else {
        //     this.link = "gis/data/index.html#/map?data="+newval.query.id;
        // }
         this.link = "museum/musum/index.html?id="+newval.query.id;
        
    }
},
//方法集合
methods: {
    toScene() {
                var scene = this.scene;
                for (let i = 0; i < this.scenes.length; i++) {
                    if (this.scenes[i].pano == this.scene) {
                        this.$router.push({
                            path: '/sceneiframe',
                            query: {
                                id: scene
                            }
                        })
                    }
                }

            },

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    //this.link = "https://gis.4dage.com/gis/data/index.html#/map?data="+this.$route.query.id;
    // if(this.$route.query.id==1||this.$route.query.id==2||this.$route.query.id==4){
    //         this.link = "model/index.html?id="+this.$route.query.id
    //     }else {
    //         this.link = "gis/data/index.html#/map?data="+this.$route.query.id;
    //     }
   // this.link = "museum/musum/index.html?id="+this.$route.query.id;
    this.link = "https://rjbwg.4dage.com/museum/musum/index.html?id="+this.$route.query.id;
    window.addEventListener('message', (e) => {
        console.log(e.data)
                this.scene = e.data;
                this.qx = e.data;
                this.toScene();
            })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .sceneiframe {
        width:100%;
        height:100%;
        iframe {
            width:100%;
            height:100%;
        }
        .top-icons {
            position: absolute;
            top: 1.5625vw;
            left: 1.5625vw;
            display: flex;
            justify-content: center;
            .icon {
                width: 2.08vw;
                &.back {
                margin-right: 1vw;
                }
            }
        }
    }
@media screen and (max-width:600px) {
    .sceneiframe {
        .top-icons {
            top: 6.67vw;
            left: 4vw;
            .icon {
                width:10.6vw;
                &.back {
                    margin-right:2vw;
                }
            }
        }
    }
}
</style>